import type { TGetEmpreendimentosFilters } from '@/http/get-empreendimentos.service'

export const empreendimentosKeys = {
  empreendimentos: ['empreendimentos'] as const,
  lista: (filtros: TGetEmpreendimentosFilters) => [...empreendimentosKeys.empreendimentos, 'lista', filtros] as const,
  disponiveis: (apenasFuturo?: boolean) =>
    [...empreendimentosKeys.empreendimentos, 'disponiveis', ...(apenasFuturo ? ['futuro'] : [])] as const,
}
